/* -------------
social embeds obserwer
----------------*/
function loadScript(src) {
    return new Promise(resolve => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        document.body.appendChild(script);
    });
}

let socialScriptsLoaded = false;

const socialSection = document.querySelector("#follow-us-tpart-section");

if (socialSection) {

    const socialObserver = new IntersectionObserver(async (entries) => {
        for (const entry of entries) {
            if (entry.isIntersecting && !socialScriptsLoaded) {
                socialScriptsLoaded = true;

                await loadScript("https://www.tiktok.com/embed.js");

                await loadScript("https://www.instagram.com/embed.js");

                socialObserver.disconnect();
            }
        }
    }, { threshold: 0.1 });

    socialObserver.observe(socialSection);
}